var _style, _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _ellipse, _g, _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon2, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRamiColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 232.1 241",
    style: {
      enableBackground: "new 0 0 232.1 241"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000083046629328630485700000003875662820345668275_);}\n\t.st1{fill:#FFFFFF;stroke:#211E1F;stroke-width:0.36;stroke-miterlimit:10;}\n\t.st2{fill:#5AA6BF;}\n\t.st3{fill:#49B7E7;}\n\t.st4{fill:#5FC4BE;}\n\t.st5{fill:#5DC0A0;}\n\t.st6{fill:#00B694;}\n\t.st7{fill:#BB2028;}\n\t.st8{fill:#CCDC54;}\n\t.st9{fill:#EBB71E;}\n\t.st10{fill:#E68425;}\n\t.st11{fill:#E92032;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:1.18;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    cx: 116.4,
    cy: 122.9,
    rx: 102.4,
    ry: 102.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000097481811754040088860000018110000117696483714_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000097481811754040088860000018110000117696483714_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 15.2,
    className: "st1",
    width: 230.5,
    height: 215.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 15.2,
    className: "st2",
    width: 23.3,
    height: 216.1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.6,
    y: 15.2,
    className: "st3",
    width: 23.3,
    height: 216.1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4,
    y: 15.2,
    className: "st4",
    width: 23.3,
    height: 216.1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 69.8,
    y: 15.2,
    className: "st5",
    width: 23.3,
    height: 216.1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92.7,
    y: 15.2,
    className: "st6",
    width: 23.3,
    height: 216.1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 208.8,
    y: 15.2,
    className: "st7",
    width: 23.3,
    height: 216.1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 15.2,
    className: "st8",
    width: 23.3,
    height: 216.1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 138.9,
    y: 15.2,
    className: "st9",
    width: 23.3,
    height: 216.1
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 162.3,
    y: 15.2,
    className: "st10",
    width: 23.3,
    height: 216.1
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 185.7,
    y: 15.2,
    className: "st11",
    width: 23.3,
    height: 216.1
  }))))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 116.4,
    cy: 123.5,
    rx: 87.6,
    ry: 87.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "90.8,131.4 95.5,137.6 103.6,126.4 109.8,126.4 109.8,105.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.3,
    y: 105.2,
    className: "st12",
    width: 7.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.8,
    y: 105.2,
    className: "st12",
    width: 7.5,
    height: 32.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "131,138 123.5,138 123.5,110.1 131.1,117.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "146,138 153.5,138 153.5,110.1 146.1,117.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "123.5,105.2 131.8,105.2 138.3,113.5 145.4,105.2 153.5,105.2 153.5,108.1 138.3,123.3  123.5,108.1  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M75.4,113.1l18.9,24.7h-9.7l-16.9-21.6v-11h15.7c0,0,8.4,0.4,9.2,10.6c0,0,0.5,7.5-5.8,10.4l-5.4-6.9 c0,0,3,0.5,3-3c0,0,0-3-2.8-3.2H75.4"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "67.8,117.8 75.4,127.6 75.4,137.8 67.8,137.8  "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M67.8,147.3c0-0.6,0.1-1.1,0.3-1.7c0.2-0.5,0.4-1,0.7-1.4c0.3-0.4,0.7-0.7,1.2-0.9s1-0.3,1.6-0.3 c0.5,0,0.9,0.1,1.2,0.2c0.3,0.1,0.6,0.3,0.9,0.5c0.2,0.2,0.4,0.4,0.6,0.6s0.3,0.4,0.3,0.6c0.1,0.2,0.1,0.4,0.2,0.5 c0,0.1,0.1,0.2,0.1,0.2h-0.5c-0.1-0.3-0.2-0.6-0.3-0.9c-0.2-0.3-0.4-0.5-0.6-0.7s-0.5-0.3-0.8-0.4c-0.3-0.1-0.6-0.1-1-0.1 c-0.5,0-1,0.1-1.4,0.3s-0.8,0.5-1,0.8s-0.5,0.8-0.7,1.2c-0.2,0.5-0.2,1-0.2,1.5s0.1,1,0.2,1.5c0.2,0.5,0.4,0.9,0.7,1.2 s0.6,0.6,1,0.8s0.9,0.3,1.4,0.3c0.4,0,0.8-0.1,1.1-0.2c0.3-0.2,0.6-0.4,0.9-0.6c0.2-0.3,0.5-0.6,0.6-0.9c0.2-0.4,0.2-0.7,0.3-1.1 H75c-0.1,0.5-0.2,0.9-0.3,1.4c-0.2,0.4-0.4,0.8-0.7,1.1c-0.3,0.3-0.6,0.5-1,0.7s-0.8,0.2-1.2,0.2c-0.6,0-1.1-0.1-1.6-0.3 s-0.9-0.5-1.2-0.9c-0.3-0.4-0.6-0.8-0.7-1.4S67.8,147.9,67.8,147.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M77.5,143.2H78v8.1h-0.5V143.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M80.9,143.2h0.6l5.1,7.5l0,0v-7.5h0.5v8.1h-0.6l-5.1-7.5l0,0v7.5h-0.5V143.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M89.1,143.6v-0.4h6.1v0.4h-2.8v7.7h-0.5v-7.7H89.1L89.1,143.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M98.8,143.2h0.5l3.2,8.1H102l-1-2.6h-3.8l-1,2.6h-0.5C95.6,151.4,98.8,143.2,98.8,143.2z M100.8,148.3 l-1.7-4.6l0,0l-1.8,4.6H100.8L100.8,148.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M109.8,145.5c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.3-0.3-0.5-0.5-0.6c-0.2-0.2-0.5-0.3-0.8-0.4 c-0.3-0.1-0.7-0.1-1-0.1c-0.2,0-0.5,0-0.7,0.1c-0.3,0.1-0.5,0.1-0.7,0.3s-0.4,0.3-0.5,0.5s-0.2,0.5-0.2,0.8s0.1,0.6,0.2,0.8 s0.4,0.4,0.6,0.5s0.6,0.2,0.9,0.3s0.7,0.1,1,0.2s0.7,0.1,1,0.2s0.6,0.2,0.9,0.4s0.5,0.4,0.6,0.6c0.2,0.3,0.2,0.6,0.2,1 s-0.1,0.8-0.3,1.1c-0.2,0.3-0.4,0.5-0.7,0.7c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.7,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.1 c-0.4-0.1-0.8-0.3-1.1-0.5c-0.3-0.2-0.6-0.5-0.7-0.9s-0.3-0.8-0.2-1.3h0.5c0,0.4,0,0.8,0.2,1.1s0.4,0.6,0.6,0.8s0.6,0.3,0.9,0.4 c0.4,0.1,0.7,0.1,1.1,0.1c0.2,0,0.5,0,0.8-0.1s0.5-0.2,0.8-0.3s0.4-0.3,0.6-0.6c0.2-0.2,0.2-0.5,0.2-0.9s-0.1-0.6-0.2-0.8 c-0.2-0.2-0.4-0.4-0.6-0.5c-0.3-0.1-0.6-0.2-0.9-0.3s-0.7-0.1-1-0.2s-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.2-0.9-0.4 c-0.2-0.2-0.5-0.4-0.6-0.6s-0.2-0.6-0.2-0.9s0.1-0.7,0.2-1c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4s0.6-0.1,0.9-0.1 c0.4,0,0.8,0.1,1.2,0.1c0.4,0.1,0.7,0.2,0.9,0.4c0.3,0.2,0.5,0.5,0.7,0.8s0.3,0.7,0.3,1.1L109.8,145.5L109.8,145.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M123.2,147.9v1.2H121v2.3h-1.2v-2.3h-2.2v-1.2h2.2v-2.3h1.2v2.3H123.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M130.6,143.2h0.5v3.7h5.1v-3.7h0.5v8.1h-0.5v-4h-5.1v4h-0.5V143.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M139.6,143.2h0.5v8.1h-0.5V143.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M143,143.2h0.5v7.7h4.5v0.4h-5V143.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M156.9,147.3c0,0.6-0.1,1.1-0.3,1.7s-0.4,1-0.7,1.4s-0.7,0.7-1.2,0.9s-1,0.3-1.6,0.3s-1.1-0.1-1.6-0.3 s-0.9-0.5-1.2-0.9s-0.6-0.8-0.7-1.4s-0.3-1.1-0.3-1.7s0.1-1.1,0.3-1.7c0.2-0.5,0.4-1,0.7-1.4s0.7-0.7,1.2-0.9s1-0.3,1.6-0.3 s1.1,0.1,1.6,0.3s0.9,0.5,1.2,0.9s0.6,0.8,0.7,1.4S156.9,146.7,156.9,147.3z M149.8,147.3c0,0.5,0.1,1,0.2,1.5 c0.1,0.5,0.4,0.9,0.6,1.2s0.6,0.6,1,0.8s0.9,0.3,1.4,0.3s1-0.1,1.4-0.3s0.8-0.5,1-0.8c0.3-0.4,0.5-0.8,0.6-1.2 c0.1-0.5,0.2-1,0.2-1.5s-0.1-1-0.2-1.5c-0.1-0.5-0.4-0.9-0.6-1.2s-0.6-0.6-1-0.8s-0.9-0.3-1.4-0.3s-1,0.1-1.4,0.3s-0.8,0.5-1,0.8 s-0.5,0.8-0.6,1.2C149.9,146.3,149.8,146.8,149.8,147.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M164.7,145.5c0-0.4-0.1-0.7-0.2-0.9c-0.1-0.3-0.3-0.5-0.5-0.6c-0.2-0.2-0.5-0.3-0.8-0.4 c-0.3-0.1-0.6-0.1-1-0.1c-0.2,0-0.5,0-0.7,0.1c-0.3,0.1-0.5,0.1-0.7,0.3s-0.4,0.3-0.5,0.5s-0.2,0.5-0.2,0.8s0.1,0.6,0.2,0.8 s0.4,0.4,0.6,0.5c0.2,0.1,0.6,0.2,0.9,0.3c0.3,0.1,0.7,0.1,1,0.2s0.7,0.1,1,0.2s0.6,0.2,0.9,0.4c0.3,0.2,0.5,0.4,0.6,0.6 c0.2,0.3,0.2,0.6,0.2,1s-0.1,0.8-0.3,1.1s-0.4,0.5-0.7,0.7s-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.1-1,0.1c-0.5,0-0.9-0.1-1.3-0.1 c-0.4-0.1-0.8-0.3-1.1-0.5s-0.6-0.5-0.7-0.9c-0.2-0.4-0.3-0.8-0.2-1.3h0.5c0,0.4,0,0.8,0.2,1.1c0.1,0.3,0.4,0.6,0.6,0.8 s0.6,0.3,0.9,0.4c0.4,0.1,0.7,0.1,1.1,0.1c0.2,0,0.5,0,0.8-0.1s0.5-0.2,0.8-0.3s0.4-0.3,0.6-0.6c0.1-0.2,0.2-0.5,0.2-0.9 s-0.1-0.6-0.2-0.8s-0.4-0.4-0.6-0.5c-0.3-0.1-0.6-0.2-0.9-0.3c-0.3-0.1-0.7-0.1-1-0.2s-0.7-0.1-1-0.2c-0.3-0.1-0.6-0.2-0.9-0.4 c-0.2-0.2-0.5-0.4-0.6-0.6c-0.2-0.2-0.2-0.6-0.2-0.9s0.1-0.7,0.2-1s0.4-0.5,0.6-0.7c0.3-0.2,0.6-0.3,0.9-0.4 c0.3-0.1,0.6-0.1,0.9-0.1c0.4,0,0.8,0.1,1.2,0.1c0.4,0.1,0.7,0.2,0.9,0.4c0.3,0.2,0.5,0.5,0.7,0.8s0.3,0.7,0.3,1.1L164.7,145.5 L164.7,145.5z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "67.8,118.1 75.4,127.9 75.5,138.1 67.8,138.1  "
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st13",
    cx: 116.7,
    cy: 122.4,
    r: 102.2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRamiColor);
export default __webpack_public_path__ + "static/media/logo-rami-color.1385a6bef181269d245a54b4151f139c.svg";
export { ForwardRef as ReactComponent };